import { Box, Button, Circle, Image, Link, Text, Tooltip } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link as QuizzesLink } from "react-router-dom";
import { quizStarted } from "../../redux/actions/action";
import { getScoreAndScorecard, loadQuizQuestions } from "../../redux/api/apiCalls";
import { ReactComponent as Calendar } from '../../svg/calendar.svg'
import { ReactComponent as Clock } from '../../svg/clock.svg'
import { ReactComponent as PlayButton } from '../../svg/play-button.svg'
import Scorecard from "./Scorecard";


export default function IndividualQuizCard({ id, title, date, time, topicTitle, topicImage, filter, attemptsLeft }) {
    const [scores, setScores] = useState([])
    const [scoreIsLoading, setScoreIsLoading] = useState(false)
    const [scoreLoadingError, setScoreLoadingError] = useState(null)
    const [scorecardOpen, setScorecardOpen] = useState(false)
    const questions = useSelector(state => state.quizQuestionsState.questions)
    const onScorecardClose = () => {
        setScores([])
        setScorecardOpen(false)
    }
    const dispatch = useDispatch()


    const scorecardHandler = () => {
        console.log("loading scores for quiz no. ", id)
        dispatch(loadQuizQuestions(id))
        getScores()
    }

    const getScores = async () => {
        setScoreIsLoading(true)
        try {
            let response = await getScoreAndScorecard(id)
            setScores(response)
            setScoreIsLoading(false)
        }
        catch (error) {
            console.log(error.message)
            setScoreLoadingError(error.message)
            setScoreIsLoading(false)
        }
    }

    useEffect(() => {
        if (scoreLoadingError) {
            alert(scoreLoadingError)
        }
    }, [scoreLoadingError])

    useEffect(() => {
        if (!scoreIsLoading && scores.length > 0) {
            setScorecardOpen(true)
        }
        // eslint-disable-next-line
    }, [scores, scoreIsLoading])

    const startQuizHandler = () => {
        dispatch(loadQuizQuestions(id))
        dispatch(quizStarted())
    }

    return (
        <Box
            d='flex'
            flexDir='column'
            width={['95%', '95%', '47%', '30%', '23%']}
            borderRadius='20px'
            bg='#ffffff'
            boxShadow='md'
            position='relative'
        >
            <Box width='100%' px='1.5rem' my='1.5rem'>
                <Tooltip
                    label={title}
                    fontSize='20px'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='400'
                    color='#ffffff'
                    bg='#1B1A1AB2'
                    placement='bottom-start'
                    hasArrow
                >
                    <Text
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontSize='18px'
                        fontWeight='700'
                        color='#1B1A1A'
                        textTransform='capitalize'
                        whiteSpace='nowrap'
                        overflow='hidden'
                        textOverflow='ellipsis'
                    >
                        {title}
                    </Text>
                </Tooltip>
            </Box>

            <Box
                d='flex'
                justifyContent='flex-start'
                alignItems='center'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                fontSize='14px'
                fontWeight='400'
                color='#1B1A1AB2'
                px='1.5rem'
                mb='1rem'
            >
                <Calendar />
                <Text ml='2'>{date ? date : 'N/A'}</Text>
            </Box>
            <Box
                d='flex'
                justifyContent='flex-start'
                alignItems='center'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                fontSize='14px'
                fontWeight='400'
                color='#1B1A1AB2'
                px='1.5rem'
                mb='1rem'
            >
                <Clock />
                <Text ml='2'>{time ? `${time} Mins` : 'N/A'}</Text>
            </Box>
            <Box
                d='flex'
                justifyContent='flex-start'
                alignItems='center'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                fontSize='14px'
                fontWeight='400'
                color='#1B1A1AB2'
                px='1.5rem'
                mb='1rem'
            >
                <Circle size='20px'>
                    <Image
                        src={topicImage}
                        fallbackSrc={"https://source.unsplash.com/random/800x600"}
                        width='100%'
                        height='100%'
                        objectFit='cover'
                        borderRadius='50%'
                    />
                </Circle>
                <Tooltip
                    label={topicTitle}
                    fontSize='14px'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='400'
                    color='#ffffff'
                    bg='#1B1A1AB2'
                    hasArrow
                >
                    <Text
                        ml='2'
                        textTransform='capitalize'
                        whiteSpace='nowrap'
                        overflow='hidden'
                        textOverflow='ellipsis'
                    >{topicTitle ? topicTitle : 'N/A'}</Text>
                </Tooltip>
            </Box>
            <Box
                px='1.5rem'
                my='1.5rem'
                d='flex'
                justifyContent='space-between'
                alignItems='center'
            >
                <Link as={QuizzesLink} to={
                    {
                        pathname: `/quizzes/${id}`,
                        state: { filter: filter }
                    }
                }
                    style={{ textDecoration: 'none' }}>
                    <Button
                        bg='linear-gradient(95.45deg, rgba(70, 163, 70, 0.57) 0.98%, #4BBD4B 100%)'
                        borderRadius='7px'
                        py={['10px', '10px', '10px', '8px', '11px']}
                        px={['18px', '18px', '18px', '15px', '19px']}
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        _hover={{ bg: 'linear-gradient(95.45deg, rgba(70, 163, 70, 0.57) 0.98%, #43aa42 100%)' }}
                        fontSize='12px'
                        fontWeight='800'
                        color='#FFFFFF'
                    >
                        View More
                    </Button>
                </Link>
                {
                    filter === 'Upcoming' &&
                    <Link as={QuizzesLink} to={
                        {
                            pathname: `/test-attempt`,
                            state: { attemptsLeft: attemptsLeft }
                        }
                    }
                        style={{ textDecoration: 'none' }}>
                        <Button
                            bg='linear-gradient(90.57deg, #7B90F7 3.35%, #3E59DE 94.78%)'
                            borderRadius='7px'
                            // p='11px 33px 11px 32px'
                            py={['10px', '10px', '10px', '8px', '11px']}
                            px={['30px', '30px', '30px', '26px', '32px']}
                            boxShadow='0px 4px 8px rgba(0, 0, 0, 0.1)'
                            d='flex'
                            justifyContent='center'
                            alignItems='center'
                            textTransform='uppercase'
                            style={{ fontFamily: 'Mulish, sans-serif', gap: '0.5rem' }}
                            _hover={{ bg: 'linear-gradient(90.57deg, #6e81dd 3.35%, #3750c6 94.78%)' }}
                            fontSize='12px'
                            fontWeight='800'
                            color='#FFFFFF'
                            onClick={startQuizHandler}
                        >
                            <PlayButton width='14px' fill='white' /> Play
                        </Button>
                    </Link>
                }

                {
                    (filter === 'Scored Above Average' || filter === "Scored Min. Marks") &&
                    <Button
                        bg='linear-gradient(273.03deg, #F24197 0.67%, rgba(242, 65, 151, 0.63) 100%)'
                        borderRadius='7px'
                        py={['10px', '10px', '10px', '8px', '11px']}
                        px={['30px', '30px', '30px', '26px', '32px']}
                        boxShadow='0px 4px 8px rgba(0, 0, 0, 0.1)'
                        d='flex'
                        justifyContent='center'
                        alignItems='center'
                        textTransform='uppercase'
                        style={{ fontFamily: 'Mulish, sans-serif', gap: '0.5rem' }}
                        _hover={{ bg: 'linear-gradient(273.03deg, #d93a86 0.67%, rgba(217, 58, 134, 0.63) 100%)' }}
                        fontSize='12px'
                        fontWeight='800'
                        color='#FFFFFF'
                        isLoading={scoreIsLoading}
                        loadingText='Loading...'
                        onClick={scorecardHandler}
                    >
                        Scorecard
                    </Button>
                }
            </Box>
            {
                scores.length === 2 &&
                <Scorecard isOpen={scorecardOpen} onClose={onScorecardClose} questions={questions.question || []} scoreDetails={scores || []} />
            }
        </Box>
    )
}